import { requestAPI } from '../../data/api'

export default function setAction(
	violationId,
	action,
	proxyPermissionLevel,
	rejectReason,
) {
	return requestAPI(
		`/violations/set-action/${violationId}?proxypermissionlevel=${proxyPermissionLevel}`,
		'POST',
		{ action, rejectReason },
	)
}
